import { render } from "./TicketListSecondaryTitle.vue?vue&type=template&id=26667ac8"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "26667ac8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26667ac8', script)) {
    api.reload('26667ac8', script)
  }
  
  module.hot.accept("./TicketListSecondaryTitle.vue?vue&type=template&id=26667ac8", () => {
    api.rerender('26667ac8', render)
  })

}

script.__file = "src/views/services/pageTitles/TicketListSecondaryTitle.vue"

export default script